
// Estilos
import styles from './modal.module.css';

// Assets
import { IoIosClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

function Modal({ title, message, onConfirm, onCancel, onClose }) {
    const { tipoUsuario } = useAuth();
    const { t, i18n } = useTranslation();
    const language = tipoUsuario === 'participante' ? i18n.resolvedLanguage : 'pt-BR';

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button className={styles.closeButton} onClick={onClose}>
                    <IoIosClose size={28} />
                </button>

                <h2 className={styles.title}>{title}</h2>

                <p className={styles.message}>{message}</p>

                <div className={styles.buttons}>
                    <button className={styles.cancel} onClick={onCancel}>{t('common.cancel', { lng: language })}</button>
                    <button className={styles.confirm} onClick={onConfirm}>{t('common.confirm', { lng: language })}</button>
                </div>
            </div>
        </div>
    );
}

export default Modal;
